import type { Schedule } from '../types';
import { WEEKDAYS } from '../types';

/**
 * 曜日別の稼働時間が保存済みの内容から変更されているかを判定する。
 *
 * 編集して元の値に戻した場合を未保存扱いしないよう、参照ではなく値で比較する。
 */
export const isScheduleDirty = (current: Schedule, baseline: Schedule): boolean =>
  WEEKDAYS.some(day => {
    const currentRange = current[day];
    const baselineRange = baseline[day];
    return currentRange.from !== baselineRange.from || currentRange.to !== baselineRange.to;
  });
